import { useTranslation } from 'react-i18next';
import type { MentionCandidate } from '../Composer';

export function MentionPopup(props: {
  candidates: MentionCandidate[];
  selected: number;
  onPick: (c: MentionCandidate) => void;
  onHover: (idx: number) => void;
}) {
  const { t } = useTranslation();
  return (
    <div className="bg-surface rounded-xl border border-separator absolute bottom-full left-0 right-0 mb-2 overflow-hidden">
      <div className="font-medium px-3 pt-2 pb-1 text-[10px] text-ink-muted">
        {t('composer.mentionTitle')}
      </div>
      <ul className="scrollbar-thin max-h-60 overflow-y-auto pb-1">
        {props.candidates.map((c, idx) => {
          const active = idx === props.selected;
          const label = c.displayName || c.username;
          return (
            <li key={c.userId}>
              <button
                type="button"
                onMouseEnter={() => props.onHover(idx)}
                // mousedown (not click) so we beat the textarea blur that
                // would otherwise close the popup before selection.
                onMouseDown={(e) => {
                  e.preventDefault();
                  props.onPick(c);
                }}
                data-active={active}
                className="rounded-lg transition-colors hover:bg-default/50 active:scale-[0.97] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/60 mx-1 flex w-[calc(100%-0.5rem)] items-center gap-2 px-3 py-1.5 text-left text-sm font-light tracking-[-0.015em] text-ink"
              >
                <span
                  className="grid h-6 w-6 shrink-0 place-items-center overflow-hidden rounded-full text-[10px]"
                  style={{ backgroundColor: 'rgb(var(--surface-input) / var(--surface-input-alpha))' }}
                >
                  {c.avatarUrl ? (
                    <img src={c.avatarUrl} alt="" className="h-full w-full object-cover" />
                  ) : (
                    label.charAt(0).toUpperCase()
                  )}
                </span>
                <span className="min-w-0 flex-1 truncate">{label}</span>
                <span className="shrink-0 text-xs text-ink-muted">@{c.username}</span>
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
